import { defineStore } from "pinia";
import { isObject } from "lodash";
import { useUser } from "./user";
import { SessionStorage } from "@/storage";
import { applicationType, initType } from "@/types/application";
import { init } from "@/api/apiclient/user";
import { useFavicon } from "@vueuse/core";

export const useSettings = defineStore("settings", {
  state: () => {
    return {
      platformId: "HDHome",
      platformIdHeader: "MANGO",
      platformFrontendId: import.meta.env.VITE_CLIENT_ID,
      authInitialized: false,
      mode: import.meta.env.MODE,
      // permissions: [] as Array<permissionType>,
      sidebaSize: SessionStorage.getOr("MangoSidebarSize", "open"),
      applicationInfo: null as null | Partial<applicationType>
    };
  },
  actions: {
    async init(): Promise<initType | null>{
      try {
        const res = await init();
        useSettings().setApplicationInfo(res.context);
        const icon = useFavicon()
        icon.value = res.context?.favicon;

        return res;
      } catch (error) {
        console.error(error);
      }
      return null;
    },
    setSidebarSize(str: string): void{
      this.sidebaSize = str;
    },
    setApplicationInfo(obj:Partial<applicationType>): void {
      this.applicationInfo = {...obj};
    }
  },
  getters: {
    cleanObj() {
      return (obj: any) => {
        return cleanObj(obj);
      };
    },
    // getPermissions(): Array<permissionType> {
    //   return this.permissions;
    // },
    getUserRoleId() {
      return (): number | null => {
        return useUser().savedRole?.id ?? null;
      };
    },
    getSidebarSize(): string {
      return this.sidebaSize;
    },
    getLogo(): string {
      if( this.applicationInfo?.logo  !== null ){
        return this.applicationInfo?.logo ?? '';
      }
      return '';
    }
  },
});

const cleanObj = (obj: any) => {
  Object.keys(obj).map((k) => {
    if (isObject(obj[k])) {
      cleanObj(obj[k]);
      if (Object.keys(obj[k]).length === 0) delete obj[k];
    } else {
      Object.keys(obj).map((k) => (obj[k] == null ? delete obj[k] : obj[k]));
    }
  });
  return obj;
};
